import React, { useEffect, useState } from 'react';

import { Steps } from '@/modules/transaction/components/Statements/components/ChangeEmailModal/ChangeEmailModal.constants';
import useEditEmailStore from '@/modules/transaction/components/Statements/components/ChangeEmailModal/stores/useEditEmail.store';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

import EditEmailModal from './components/EditEmailModal';
import EmailVerificationModal from './components/EmailVerificationModal';
import SuccessfullyChangedModal from './components/SuccessfullyChangedModal';

interface Props {
  onClose: () => void;
}

const ChangeEmailModal: React.FC<Props> = ({ onClose }) => {
  const [step, setStep] = useState(Steps.EditEmail);
  const { employee } = useEmployeeStore();
  const { setState, handleReset } = useEditEmailStore();

  useEffect(() => {
    if (employee?.employerProvidedEmail) {
      setState({ isEmployeeEmailPreferred: employee?.isEmployeeEmailPreferred });
    }
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  useEffect(() => handleReset, []);

  return (
    <>
      {step === Steps.EditEmail && (
        <EditEmailModal
          onClose={onClose}
          setStep={setStep}
        />
      )}

      {step === Steps.VerifyEmail && (
        <EmailVerificationModal
          onClose={onClose}
          setStep={setStep}
        />
      )}

      {step === Steps.SuccessfullyChanged && (
        <SuccessfullyChangedModal
          onClose={onClose}
        />
      )}
    </>
  );
};

export default ChangeEmailModal;
